import { render, staticRenderFns } from "./LazyList.vue?vue&type=template&id=620f6b76&scoped=true"
import script from "./LazyList.vue?vue&type=script&lang=js"
export * from "./LazyList.vue?vue&type=script&lang=js"
import style0 from "./LazyList.vue?vue&type=style&index=0&id=620f6b76&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620f6b76",
  null
  
)

export default component.exports